import USER_ROLES from 'constants/user-roles.constant';
import { restrictions } from 'state/features-list/constants';

/* 

  WPO (Work Place Options) is built using a TH1 API wrapper for GraphQL Implementation around WPO’s Online Scheduler API
  This work directly supports the business goal of migrating 2.8M employees (at the time) onto the WPO clinical model by the end of 2025 
  and the product goal of allowing TH1 users to access WPO counsellors natively.

  https://www.workplaceoptions.com/
  https://www.workplaceoptions.com/privacy-policy/

  The intent is to take the TMH Booking experience and convert it to a less complicated and broader experience
  provided by WPO to allow for a greater number of users to access counselling services as TMH has larger restrictions
  and has larger complexity due to integrations with Dynamics and Symphponi case management systems.

 */

const wpoBookingModule = {
  form: {
    name: 'wpoBookingForm',
    url: '/wpo-booking/form',
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "wpo-booking-form" */ './wpo-booking.container'
        ),
      ]).then(([component]) => {
        return component;
      }),
    restrictions: [restrictions['wpo_online_scheduling']],
    data: {
      title: 'wpo_booking.module.form_page_title',
      includeInMenu: false,
      hideFooter: true,
      authorizedRoles: [USER_ROLES.employee],
    },
  },
  confirmationScreen: {
    name: 'wpoBookingConfirmationScreen',
    url: '/wpo-booking/booking-confirmation',
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "wpo-booking-confirmation-screen" */ './confirmation-screen/wpo-booking-confirmation-screen'
        ),
      ]).then(([component]) => {
        return component;
      }),
    restrictions: [restrictions['wpo_online_scheduling']],
    data: {
      title: 'wpo_booking.module.confirmation_page_title',
      includeInMenu: false,
      hideFooter: true,
      authorizedRoles: [USER_ROLES.employee],
    },
  },
};

export default wpoBookingModule;
